module.exports = __webpack_public_path__ + "img/blank.37f922ae.png";